import { useMutation } from "@connectrpc/connect-query";
import { ReservationService } from "@viajero/proto/guest/v1";

/**
 * ReservationService.CancelReservation を connect-query mutation でラップするフック。
 *
 * 予約キャンセル画面 (/reservations/{予約トークン}/cancel) の「キャンセル実施」で予約を
 * キャンセルし、キャンセルポリシー (§7.4) に基づく返金を行う。`x-reservation-token` ヘッダは
 * lib/client.ts の reservationTokenInterceptor が付与するため、呼び出し側は予約トークンを
 * 意識しなくてよい (§6.6)。idempotency_key で冪等化されるため、同一入力での再送は同じ結果を返す。
 */
export function useCancelReservation() {
  return useMutation(ReservationService.method.cancelReservation);
}
